module.exports = __webpack_public_path__ + "static/media/logo.51ff592e.png";